module.exports = __webpack_public_path__ + "static/media/resource3.83bbd997.svg";